import { observable } from "mobx";
import { entities } from "sb-bff-integration";
import { MarketTemplate, SelectionType, CardType } from "../../data";
import { selectionsOrdering, emptySelectionPointBox } from "../../constants";
import { findSelectionsOrdering, mapSelections, StaticDecimalLocalizator } from "..";
import { isNumber } from "util";
/**
 * Order selections in markets for specific sport
 * @param selections
 * @param template
 */
export const fillEmptySelections = (selections, template, cardType) => {
    const selectionType = findSelectionsType(selections);
    const order = selectionsOrdering[template][findSelectionsOrdering(template, pickSelectionType(getSelectionTypes(selections)))];
    if (MarketTemplate[template] === MarketTemplate.ThreeBox) {
        return observable.array(addPointsText(mapSelections(selections, order), cardType, selectionType));
    }
    const selectionsSet = getSelections(selections);
    const result = mapSelections(selectionsSet.length ? selectionsSet : selections, order);
    if (MarketTemplate[template] === MarketTemplate.PointBox) {
        result.unshift(Object.assign({}, emptySelectionPointBox));
        result[0].points = getPoints(selections);
    }
    return observable.array(addPointsText(result, cardType, selectionType));
};
/**
 * Pick selection outcomeType to use for ordering find
 * @param types
 */
const pickSelectionType = (types) => {
    return types.find(t => t === entities.OutcomeType.Draw || t === entities.OutcomeType.Tie) || types[0];
};
/**
 * Gather all selection outcomeTypes into array
 * @param selections
 */
const getSelectionTypes = (selections) => {
    let result = [];
    selections.forEach(s => s.outcomeType && result.push(s.outcomeType));
    return result;
};
/**
 * Get selection for types HC or OU
 * @param selections
 */
const getSelections = (selections) => {
    let selectionsSet = [];
    let type = findSelectionsType(selections);
    let mainLineSelections = [];
    type && (mainLineSelections = filterByMainPointLine(selections));
    selectionsSet = mainLineSelections.length
        ? mainLineSelections
        : reduceSelections(selections);
    return selectionsSet;
};
/**
 * Find if selections are of type HC or OU
 * @param selections
 */
const findSelectionsType = (selections) => {
    return (selections.find(s => s.outcomeType === "Over")
        ? SelectionType.OU
        : selections.find(s => s.outcomeType === "Home")
            ? SelectionType.HC
            : undefined);
};
/**
 * Get all selections with tag of "MainPointLine"
 * @param selections
 */
export const filterByMainPointLine = (selections) => {
    if (selections.length === 2) {
        return selections;
    }
    return selections.filter(s => s && s.tags && s.tags.indexOf("MainPointLine") > -1);
};
/**
 * Reduce selections to show, in case of no MainPointLine selections
 * @param selections
 * @param type
 */
export const reduceSelections = (selections) => {
    let reduced = [];
    let firstSelectionWithPoints = selections.find(s => isNumber(s.points));
    return !firstSelectionWithPoints
        ? reduced
        : pickSelectionsByPoints(firstSelectionWithPoints, selections);
};
/**
 * Use s1 points to find another selection with the same points
 * @param s1
 * @param selections
 */
const pickSelectionsByPoints = (s1, selections) => {
    let reduced = [s1];
    let s2 = selections.find(s => isNumber(s.points)
        && s.id !== s1.id
        && Math.abs(s.points) === (s1.points && Math.abs(s1.points)));
    s2 && reduced.push(s2);
    return reduced;
};
/**
 * Get points to assign to pointsText
 * @param selections
 */
export const getPoints = (selections) => {
    if (selections.length === 2) {
        return selections[0].points || 0;
    }
    let s = selections.find(s => s.points !== null && s.tags && s.tags.indexOf("MainPointLine") > -1) || selections.find(s => isNumber(s.points));
    return s && s.points ? s.points : 0;
};
/**
 * Assign points value to pointsText
 * @param selections
 */
const addPointsText = (selections, cardType, selectionType) => {
    let checkTypes = (cardType === CardType.American && selectionType === SelectionType.HC);
    selections.forEach((s) => {
        if (s.points === null || s.points === undefined) {
            s.pointsText = "";
            return s;
        }
        let sign = checkTypes && s.points > 0 ? "+" : "";
        s.pointsText = `${sign}${localizePoint(s.points)}`;
        return s;
    });
    return selections;
};
const localizePoint = function (point) {
    const localizator = StaticDecimalLocalizator.getInstance();
    return typeof localizator !== "undefined" ? localizator.localizePoint(point) : point.toString();
};
//# sourceMappingURL=fillEmptySelections.js.map